module.exports = __webpack_public_path__ + "static/media/Twitter fav.c228a51f.png";